import React, { useEffect } from 'react';
import { useUser } from '@forge/sso-client';
import { useSelector, useDispatch } from 'react-redux';
import { setUserInfo } from '../../slices/userProfileSlice';
import {
  getOnBoardingAPIStatus,
  getOnBoardingStatus,
} from '../../slices/onBoardingSlice';

export const SetAppToken = (props: any) => {
  const dispatch = useDispatch();
  const [user] = useUser();
  const userOnboardAPIStatus = useSelector(getOnBoardingAPIStatus);

  useEffect(() => {
    if (user) {
      const {
        avatar: user_img_url,
        email = '',
        family_name = '',
        given_name = '',
        name = '',
        preferred_username: eid = '',
        sub = '',
      } = user.profile;
      dispatch(
        setUserInfo({
          user_img_url: user_img_url,
          email: email,
          family_name: family_name,
          given_name: given_name,
          name: name,
          eid: eid,
          sub: sub,
        })
        );
        if (userOnboardAPIStatus === 'idle') {
          dispatch(getOnBoardingStatus());
      }
    }
  }, [user]);


  return <React.Fragment>{props.children}</React.Fragment>;
};
